/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {  memo, useCallback, useEffect, useMemo } from 'react';
import './AcDashboard.css'
import { useAppDispatch, useAppSelector } from '../../../rmsReduxStore/rmsReduxHooks';
import {fetchIntervalRangeRefData, getFilterSelectedValue, setFilterData } from '../../../rmsReduxStore/reduxExports';
import { RectangularSkeleton } from '../../../globalUtils/SkeletonDesign/SkeletonDesign';
import { Icon, IconWithTooltip } from '../../../globalUtils/globalIcons';
import { useNavigate } from 'react-router-dom';
import { formatNumberWithCommas, useEffectOnce } from '../../../globalUtils/globalHooks';
import { AutoRefresh } from '../../../globalUtils/globalExports';
import { getacalarmsReducer, getAcDashboardReducer, getAcReferenceDataReducer } from '../../rmsReduxStore/acReduxExports';
import { fetchNewAcDashboardHeaderData, fetchNewAcDashboardRealTimeGunInfo ,fetchNewAcDashboardChargingSessionsList, fetchNewDashboardAcConnectivityMediumData, fetchNewDashboardAcChargingSessionTrendList, fetchNewDashboardAcEnergyTrendList, fetchNewDashboardAcChargingVsIdleList, fetchNewAcDashboardAttentionRequiredList, fetchNewDashboardAcOverallUptimeList } from '../../rmsReduxStore/acDashboardRedux/acDashboardCreator';
import { fetchAcAlarmCardCountData, fetchAcAlarmListData } from '../../rmsReduxStore/acAlarmsRedux/acAlarmCreators';
import AcAlarmSummary from './AcAlarmSummary';
import { getAcFilterSelectedValue, getCurrentAcFiltersValues, setAcFilterData } from '../../rmsReduxStore/acFiltersRedux/acFiltersCreators';
import AcFilterLayout,{ FilterProp } from '../../../globalUtils/FilterLayout/AcFilterLayout';
import Overview from './Overview';
import AcChargingSession from './AcChargingSessions';
import AcChargingSessionTrend from './AcChargingSessionTrend';
import { fetchAcChargerProductTypeReferenceData, fetchAcChargerStationReferenceData, fetchAcChargerVisibleIdReferenceData } from '../../rmsReduxStore/acReferenceDataRedux/acReferenceDataCreator';
import AcEnergyTrendChart from './AcEnergyTrendChart';
import AcChargingVsIdleChart from './AcChargingVsIdleChart';
import { setRedirectedStateForAcChargerFilters } from '../../rmsReduxStore/acChargersRedux/acChargerCreators';
import AcAttentionRequiredChargers from './AcAttentionRequiredChargers';
import AcOverAllUpTime from './AcOverAllUpTime';


const AcDashboard = memo(function AcDashboard() {
  const { newDashboardHeaderData } = useAppSelector(getAcDashboardReducer);
  const {newDashboardRealTimeGunsInfo} =useAppSelector(getAcDashboardReducer)
  const { acCustomerReferenceData, chargerProductTypeReferenceData } = useAppSelector(getAcReferenceDataReducer);
  const {pulseAlarmLoader} = useAppSelector(getacalarmsReducer);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

const headerCardConstants = [
    {
        text: 'Customers',
        id: 'customers',
        redirectLink:'/ac/customers',
        icon: 'newdashboard-customer dashboard-header-icon',
        tooltipText: '',
        bgcolor: '#D6D9FF'
    },
    {
        text: 'Chargers',
        id: 'totalChargers',
        icon: 'newdashboard-charger dashboard-header-icon',
        redirectLink: '/ac/manage-chargers',
        filterId:'all',
        tooltipText: '',
        bgcolor: '#FFE4CC'
    },
    {
        text: 'Online Chargers',
        id: 'onlineChargers',
        icon: 'newdashboard-online-charger dashboard-header-icon',
        // redirectLink:'/customers'
        tooltipText: '',
        bgcolor: '#BEFFD5',
        filterId:'Online',
        redirectLink: '/ac/manage-chargers',
    },
    {
        text: 'Offline Chargers',
        id: 'offlineChargers',
        icon: 'newdashboard-offline-charger dashboard-header-icon',
        // redirectLink:'/customers'
        tooltipText: '',
        bgcolor: '#E6E6E6',
        cardClassName: '',
        filterId:'Offline',
        redirectLink: '/ac/manage-chargers'
    },
    {
        text: 'RMS Disable',
        id: 'rmsDisable',
        icon: 'newdashboard-offline-charger dashboard-header-icon',
        // redirectLink:'/customers'
        tooltipText: '',
        bgcolor: '#E6E6E6',
        cardClassName: '',
        filterId:'RmsDisable',
        redirectLink: '/ac/manage-chargers'
    },
    // {
    //     text: 'CMS Connectivity',
    //     id: 'cmsConnectivity',
    //     icon: 'newDashboard__cms__connectivity__icon ',
    //     // redirectLink:'/customers'
    //     cardClassName: '',
    //     tooltipText: '',
    //     bgcolor: '#207D1133'
    // },
]

    const fetchAlarmSummaryData = (filters: any) => {
     // TODO: Remove this filtering
        dispatch(fetchAcAlarmCardCountData({ filters: getCurrentAcFiltersValues('acdashboard') }));
        dispatch(fetchAcAlarmListData({ filters:filters, pageSize: 8, pageNumber: 1 }))
    }

    const handleHeaderCardClick = useCallback(async (e, card) => {
        const  offlinefiltersAppliedValue= await getAcFilterSelectedValue('offlineFiveDays','acdashboard',false)
        if(offlinefiltersAppliedValue && offlinefiltersAppliedValue[0].value==='true' && (card.text==='Chargers' ||card.text==='Offline Chargers' )) return;
        e?.stopPropagation();
        // if (card?.id === 'cmsConnectivity') 
        //     return;
        const currentCustomerFilterValue = await getAcFilterSelectedValue('customer','',true);
        
        const customersToInclude = currentCustomerFilterValue && currentCustomerFilterValue.length > 0 ? currentCustomerFilterValue : null
         await setAcFilterData(null, '', 'acchargers', 'CLEAR', false)(dispatch);
         setRedirectedStateForAcChargerFilters(true, card?.filterId, null, null, 'acdashboard',customersToInclude)(dispatch)
            .then((res) => {
            if (res === 'Action dispatched successfully') {
                navigate(card?.redirectLink, {
                state: { chargerStatusId: card?.filterId }
                });
            }
            })
            .catch((error) => {
            console.error('Error dispatching action:', error); // Handle error
            });
    }, [dispatch, setRedirectedStateForAcChargerFilters, navigate])

    const fetchDashBoardData = useCallback((val, showLoader): void => {
      dispatch(fetchNewAcDashboardHeaderData({ filters: val?.filters }));
      fetchAlarmSummaryData(getCurrentAcFiltersValues('acalarms'));
      fetchChargingSessionsData(val?.filters);
      fetchOverViewData(val?.filters);
      const chargingSessionTrendScreenFilters = getCurrentAcFiltersValues('chargingSessionTrend');
       fetchChargingSessionTrendData(val?.filters,chargingSessionTrendScreenFilters)
       fetchEnergyTrendData(val?.filters)
       const chargingVsIdleFilters = getCurrentAcFiltersValues('chargingVsIdle');
       fetchChargingVsIdleData(val?.filters,chargingVsIdleFilters)
       fetchAttentionRequiredData(val?.filters)
       const overallUptimeFilters = getCurrentAcFiltersValues('overallUptime');
       fetchOverallUptimeData(val?.filters, overallUptimeFilters)

    } , [fetchNewAcDashboardHeaderData]);


      const onRefeshCallBack = useCallback(() => {
       dispatch(fetchNewAcDashboardHeaderData({ filters: [] }));
       fetchAlarmSummaryData([]);

      }, [getCurrentAcFiltersValues,fetchDashBoardData])






    const handleFilterDataChange = useCallback(async (val, filterKey, isGlobal) => {
        const res = await setAcFilterData(val, filterKey, 'acdashboard', 'SET', isGlobal ? isGlobal : false)(dispatch)
        if (res?.message === 'Action dispatched successfully') {
        fetchDashBoardData({ filters: res?.filters }, false)
        }
    }, [dispatch, setFilterData, fetchDashBoardData])

    const dashboardFilterProps: FilterProp[] = useMemo(() => {
        return [
          {
            filterLabel: 'Product Type',
            filterType: 'dropdown',
            filterId: 'chargerType',
            filterDropdownProps: {
              selectValue: getFilterSelectedValue('productType', 'acdashboard', false),
              selectOptions:  chargerProductTypeReferenceData ?? [],
              handleSelectOptionChange: (val): void => {
                handleFilterDataChange(val, 'productType', false)
              },
              selectDropDownId: 'dashboard-charger-type-filter-dropdown',
              isMultiSelect: true,
              renderToBody:true
            }
            
          }
        ]
      }, [getFilterSelectedValue, handleFilterDataChange])



    const getFilteredFilters = (widget: string, filters: any) => {
        const filterKeyList = ['customer', 'productType', 'offlineFiveDays']; //offlinefilter , 'offlineFiveDays'
        switch(widget) {
            case 'alarmStatistics':
            case 'alarmSummary':
                filterKeyList.push('severity');
                break;
            case 'failedTransaction':
                //This filter has been moved to its local screen
                // filterKeyList.push('failedTransactionRange');
                break;
            case 'chargingSessions':
                filterKeyList.push('sessionIntervalRange');
                break;
            case 'chargingSessionTrend':
                //This filter has been moved to its local screen
                 //filterKeyList.push('sessionChargingIntervalRange');
                break;
            case 'chargingVsIdle':
                //This filter has been moved to its local screen
                // filterKeyList.push('idleChargingIntervalRange');
                break;
            case 'energyTrend':
                filterKeyList.push('energyConsumptionIntervalRange');
                break;
            case 'overallUptime':
                //This filter has been moved to its local screen
                // filterKeyList.push('uptimeIntervalRange');
                break;
            case 'attentionRequired':
                filterKeyList.push('keyType');
                break;
            case 'overview':
                break;
            case 'efficiencyTrend':
                filterKeyList.push('energyEfficiencyRange');
                break;
            case 'reactiveEnergyConsumptionTrend':
                filterKeyList.push('reactiveEnergyRange');
                break;
            default:
                break;
        }

        return filters.filter(item => filterKeyList.includes(item.key))
    }


    const fetchOverViewData = (filters: any) => {
        const filterList = getFilteredFilters('overview', getCurrentAcFiltersValues('acdashboard'));
        dispatch(fetchNewAcDashboardRealTimeGunInfo({ filters: filterList }));
        dispatch(fetchNewDashboardAcConnectivityMediumData({ filters: filterList }));
    }

    const fetchFilterSelectedValues = (filterKey: string) => {
            return getAcFilterSelectedValue(filterKey, 'acdashboard', false);
        }
    const handleOfflineClick = (filters: any) => {
        fetchDashBoardData(filters, false);
    }

    useEffect(()=>{
       const filters = getCurrentAcFiltersValues('acdashboard');
        const filterList = getFilteredFilters('chargingSessions', filters);
       dispatch(fetchNewAcDashboardHeaderData({ filters:filters }));
       fetchAlarmSummaryData(getCurrentAcFiltersValues('acalarms'));
        const fetchTypeValues = getAcFilterSelectedValue('chargingSessionFetchType', 'acdashboard', false);
       dispatch(fetchNewAcDashboardChargingSessionsList({ filters: filterList, fetchType: fetchTypeValues?.[0]?.value || 'energyConsumed' }));
       fetchOverViewData(filters)
       dispatch(fetchAcChargerStationReferenceData())
       dispatch(fetchAcChargerVisibleIdReferenceData());
       dispatch(fetchAcChargerProductTypeReferenceData());
       const chargingSessionTrendScreenFilters = getCurrentAcFiltersValues('chargingSessionTrend');
       fetchChargingSessionTrendData(filters,chargingSessionTrendScreenFilters)
       fetchEnergyTrendData(filters)
       const chargingVsIdleFilters = getCurrentAcFiltersValues('chargingVsIdle');
       fetchChargingVsIdleData(filters,chargingVsIdleFilters)
       fetchAttentionRequiredData(filters)
       const overallUptimeFilters = getCurrentAcFiltersValues('overallUptime');
       fetchOverallUptimeData(filters, overallUptimeFilters)

    },[])


    const fetchChargingSessionsData = (filters: any) => {
        const filterList = getFilteredFilters('chargingSessions', filters);
        const fetchTypeValues = getAcFilterSelectedValue('chargingSessionFetchType', 'acdashboard', false);
        dispatch(fetchNewAcDashboardChargingSessionsList({ filters: filterList, fetchType: fetchTypeValues?.[0]?.value || 'energyConsumed' }));
    }


    const fetchChargingVsIdleData = (dashboardV2Filters:any,chargingVsIdleFilters: any) => {
            // const filterList = getFilteredFilters('chargingVsIdle', filters);
            const newDashboardScreenFilters = dashboardV2Filters.filter(item=>item.key ==='customer' || item.key ==='productType' || item.key ==='offlineFiveDays');
            const chargingVsIdleScreenFilters = chargingVsIdleFilters
            const combinedFilters = [...newDashboardScreenFilters,...chargingVsIdleScreenFilters]
            dispatch(fetchNewDashboardAcChargingVsIdleList({ filters: combinedFilters }));
        }

useEffectOnce(()=>{
  dispatch(fetchIntervalRangeRefData());
    });


    const fetchChargingSessionTrendData = (filters:any,chargingSessionTrendFilters: any) => {
        // const filterList = getFilteredFilters('chargingSessionTrend', filters);
        const newDashboardScreenFilters = filters.filter(item=>item.key ==='customer' || item.key ==='productType' || item.key ==='offlineFiveDays');
        const chargingSessionTrendScreenFilters = chargingSessionTrendFilters
        const combinedFilters = [...newDashboardScreenFilters,...chargingSessionTrendScreenFilters ]
        dispatch(fetchNewDashboardAcChargingSessionTrendList({ filters: combinedFilters }));
    }

    const fetchEnergyTrendData = (filters: any) => {
        const filterList = getFilteredFilters('energyTrend', filters);

        dispatch(fetchNewDashboardAcEnergyTrendList({ filters: filterList }));
    }

    // Combines the dashboard level filters with the overall uptime widget's own filters
    const fetchOverallUptimeData = (dashboardV2Filters: any, overallUptimeFilters: any) => {
        const newDashboardScreenFilters = dashboardV2Filters.filter(item => item.key === 'customer' || item.key === 'productType' || item.key === 'offlineFiveDays');
        const combinedFilters = [...newDashboardScreenFilters, ...(overallUptimeFilters ?? [])]
        dispatch(fetchNewDashboardAcOverallUptimeList({ filters: combinedFilters }));
    }

    const fetchAttentionRequiredData = (filters: any) => {
        const filterList = getFilteredFilters('attentionRequired', filters);
        dispatch(fetchNewAcDashboardAttentionRequiredList({ filters: filterList }));
    }

  return (
   <>
    <div className="dashboard new-dashboard-container">
            <div className="new-dashboard-header-container">
                <div className='new-dashboard-header-wrap'>
                    <div className='new-dashboard-header-left'>
                        <div className='new-dashboard-header-heading'>Dashboard</div>
                        <div className="app__dashboard__header-left">
                            <div className="app__dashboard__header-bottom-auto-refresh-wrap">
                                <AutoRefresh
                                    refreshDate={newDashboardHeaderData?.lastRefreshTime ?? ''}
                                    containerClassName="dashboard__auto__refresh__component"
                                    onRefreshCallback={onRefeshCallBack}
                                    pathName="/newDashboard"
                                    refreshLocation={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="app__dashboard__header-right">
                        <AcFilterLayout requiredReferenceDataCallbacks={['chargerType']}
                        filters={dashboardFilterProps} handleFilterDataChange={handleFilterDataChange} screen='newDashboard' />
                    </div>
                </div>
                <div className="new__dashboard__header-cards">
                    {headerCardConstants?.map((card, index) => {
                        return ( 
                            <div
                                key={'card' + index}
                                className={'new__dashboard__header-card ' + card?.id}
                            >
                                { !newDashboardHeaderData ?
                                    <RectangularSkeleton  skeletonContainerClassName='' />
                                :<>
                                <div style={{ position: 'absolute', zIndex: 999, scale: 0.9, right: 0 }}>
                                <Icon
                                containerClassName="card__background-icon"
                                iconClassName="newdashboard-header-icon"
                                />
                                </div>
                                    
                                 <div
                                    key={index}
                                    className={'card ' + card?.cardClassName}
                                    style={{ backgroundColor: card?.bgcolor }}
                                    onClick={async (e) => await handleHeaderCardClick(e, card)}
                                >
                                    <div className="card__header">
                                        <Icon
                                            containerClassName={'card__header__icon'} iconClassName={card?.icon}
                                        />
                                        <div className="card__header__text">
                                            {card?.text}
                                        </div>
                                            { card?.tooltipText && card?.tooltipText?.length>0 && <IconWithTooltip iconClassName='rms_info_icon-black' toolTipText={card?.tooltipText} containerClassName='charger__health__status-header-info' />}
                                    </div>
                                    <div className="card__footer__wrap">
                                        <div className="card__header__count">
                                        {
                                        newDashboardHeaderData && newDashboardHeaderData[card?.id] ? formatNumberWithCommas(newDashboardHeaderData[card?.id]) : newDashboardRealTimeGunsInfo && newDashboardRealTimeGunsInfo[card?.id] ? formatNumberWithCommas(newDashboardRealTimeGunsInfo[card?.id]) : 0}
                                        </div>
                                    </div>
                                </div>
                                </>


                                }
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className='dashboard-body-container'>
                <div className='new__dashboard__row new__dashboard__widget new-dashboard-overview-container'>
                    <Overview handleFilter={fetchOverViewData} getFilterValue={fetchFilterSelectedValues} handleOfflineClick={handleOfflineClick} />
                </div> 
                <div className='new__dashboard__widget charging-session-container'>
                    <AcChargingSession handleFilter={fetchChargingSessionsData} getFilterValue={fetchFilterSelectedValues}/>
                </div>
                <div className='new__dashboard__widget dashboard-active-alarm-container'>
                    <AcAlarmSummary loader={false} isNewDashBoard={true} getFilterValue={fetchAlarmSummaryData} />
                </div>
                <div className='new__dashboard__widget overall-uptime-container'>
                    <AcOverAllUpTime handleFilter={fetchOverallUptimeData} getFilterValue={fetchFilterSelectedValues} />
                </div>
                <div className='new__dashboard__widget charging-session-trend-container'>
                    <AcChargingSessionTrend handleFilter={fetchChargingSessionTrendData} getFilterValue={fetchFilterSelectedValues}/>
                </div>
                <div className='new__dashboard__widget action-required-container'>
                    <AcAttentionRequiredChargers handleFilter={fetchAttentionRequiredData} getFilterValue={fetchFilterSelectedValues} />
                </div>
                <div className='new__dashboard__widget charging-idle-time-container'>
                    <AcChargingVsIdleChart handleFilter={fetchChargingVsIdleData} getFilterValue={fetchFilterSelectedValues}/>
                </div>
                <div className='new__dashboard__widget energy-consumption-container'>
                    <AcEnergyTrendChart handleFilter={fetchEnergyTrendData} getFilterValue={fetchFilterSelectedValues}/>
                </div>
            </div>
   </div>

   </>
  );
});

export default AcDashboard;
